import { fetcher } from '@commenda/utils';

type ArchiveMarketplaceServiceProps = {
  id: string;
};

const baseURL = 'marketplace/product/archive';

export async function archiveMarketplaceService({
  id,
}: ArchiveMarketplaceServiceProps) {
  try {
    return await fetcher(`${baseURL}/${id}`, {
      method: 'POST',
    });
  } catch (err) {
    console.error(err);
    return err;
  }
}
